export default "__VITE_ASSET__cbc8469c__"